import { render, staticRenderFns } from "./project-form.component.vue?vue&type=template&id=6bece246&scoped=true&"
import script from "./project-form.component.vue?vue&type=script&lang=ts&"
export * from "./project-form.component.vue?vue&type=script&lang=ts&"
import style0 from "./project-form.component.vue?vue&type=style&index=0&id=6bece246&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bece246",
  null
  
)

export default component.exports